<template>
  <component
    :is="componentMap[props.fieldType]"
    :model-value="mutableValue"
    hide-label
    :multiple="props.fieldType === 'MULTICOMBO'"
    :dropdown="props.fieldType === 'MULTICOMBO'"
    @update:modelValue="mutableValue = $event"
  ></component>
</template>
<script setup>
const CurrencyInput = defineAsyncComponent(() => import('core-ui/components/inputs/currencyInput.vue'))
const PercentageInput = defineAsyncComponent(() => import('core-ui/components/inputs/percentageInput.vue'))
const BidAdjustment = defineAsyncComponent(() => import('core-ui/components/inputs/bidAdjustment.vue'))
const props = defineProps({
  modelValue: {
    type: [String, Array, Boolean],
    default: undefined
  },
  fieldType: {
    type: String,
    default: 'TEXT'
  }
})
const componentMap = {
  ENUM: 'p-select',
  TEXT: 'p-input-text',
  BOOLEAN: 't-checkbox',
  ENUM_TYPE_AHEAD: 't-auto-complete',
  MULTI: 't-multi-input',
  MULTICOMBO: 't-auto-complete',
  NUMBER: 'p-input-number',
  PERCENTAGE: BidAdjustment,
  BASIC_PERCENTAGE: PercentageInput,
  CURRENCY: CurrencyInput
}
const emit = defineEmits(['update:modelValue'])
const mutableValue = computed({
  get () {
    return props.modelValue
  },
  set (value) {
    emit('update:modelValue', value)
  }
})
</script>
